import { Icon } from "@/components/ui/Icon";
import { navSection } from "@/lib/data";
import type { NavRoute } from "@/lib/data";
import { routeMatches } from "@/lib/routing";

interface MobileSubTabsProps {
  sectionId: string;
  route: NavRoute;
  navigate: (target: NavRoute) => void;
}

/**
 * Ekrany, na których pasek dublował nawigację samej strony (uwaga wspólnika 29.07:
 * „na stronie startowej nie potrzebujemy duplikować tej belki", „3× powtarzamy te
 * same narzędzia"):
 *  - `hub` — pod spodem jest pełna siatka kafli narzędzi,
 *  - `gallery` — strona ma własne „Pusta oferta / Nowa oferta",
 *  - `project` — otwarta oferta ma własny pasek sekcji (OfferSectionsNav),
 *  - `offer` — kreator jest pełnoekranowy i ma własne kroki.
 * Zostaje tam, gdzie naprawdę przełącza widok: narzędzia Studia, Galeria zdjęć,
 * Agencja, Konto, Panel admina.
 */
const ROUTES_WITHOUT_SUBTABS = new Set(["hub", "gallery", "project", "offer"]);

export function MobileSubTabs({ sectionId, route, navigate }: MobileSubTabsProps) {
  const sec = navSection(sectionId);
  if (ROUTES_WITHOUT_SUBTABS.has(route.name)) return null;
  if (!sec || sec.items.length < 2) return null;

  return (
    <div className="msubtabs">
      <div className="msubtabs__track">
        {sec.items.map((it, i) => {
          // Ta sama reguła co w SubNav (desktop) — inaczej na mobile podświetlały
          // się dwie zakładki naraz (np. „Wszystkie oferty" + „Archiwum").
          const active = routeMatches(route, it.route);
          return (
            <button
              key={i}
              className={`mchip ${active ? "is-active" : ""}`}
              style={active && it.accent ? ({ "--tool": it.accent } as React.CSSProperties) : undefined}
              onClick={() => navigate(it.route)}
            >
              <Icon name={it.icon} />
              <span>{it.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
